import { render, staticRenderFns } from "./PickGif.vue?vue&type=template&id=d87201ce&scoped=true&"
import script from "./PickGif.vue?vue&type=script&lang=ts&"
export * from "./PickGif.vue?vue&type=script&lang=ts&"
import style0 from "./PickGif.vue?vue&type=style&index=0&id=d87201ce&scoped=true&lang=less&"
import style1 from "./PickGif.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d87201ce",
  null
  
)

export default component.exports